import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { logger } from '@/lib/telemetry/logger';
import { useFundingChrome } from './funding-chrome';
export function useFundingEntryProfile(open, profileOnly, title, onClose) {
  const $ = _c(29);
  const chrome = useFundingChrome(title);
  const pending = useRef(false);
  const requested = useRef(false);
  const entered = useRef(false);
  let t0;
  if ($[0] !== chrome || $[1] !== open) {
    t0 = () => {
      if (!open) {
        pending.current = false;
      } else {
        if (pending.current && chrome.hasProfile) {
          pending.current = false;
          chrome.openProfile();
        }
      }
    };
    $[0] = chrome;
    $[1] = open;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== chrome.hasProfile || $[4] !== chrome.openProfile || $[5] !== open) {
    t1 = [open, chrome.hasProfile, chrome.openProfile];
    $[3] = chrome.hasProfile;
    $[4] = chrome.openProfile;
    $[5] = open;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useEffect(t0, t1);
  let t2;
  if ($[7] !== chrome || $[8] !== onClose || $[9] !== open || $[10] !== profileOnly) {
    t2 = () => {
      if (!open) {
        requested.current = false;
        entered.current = false;
        return;
      }
      if (!profileOnly) {
        return;
      }
      if (!requested.current && chrome.hasProfile) {
        requested.current = true;
        chrome.openProfile();
      } else {
        if (requested.current && !chrome.picker) {
          entered.current = true;
        } else {
          if (entered.current && chrome.picker) {
            onClose();
          }
        }
      }
    };
    $[7] = chrome;
    $[8] = onClose;
    $[9] = open;
    $[10] = profileOnly;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== chrome.hasProfile || $[13] !== chrome.openProfile || $[14] !== chrome.picker || $[15] !== onClose || $[16] !== open || $[17] !== profileOnly) {
    t3 = [open, profileOnly, chrome.hasProfile, chrome.picker, chrome.openProfile, onClose];
    $[12] = chrome.hasProfile;
    $[13] = chrome.openProfile;
    $[14] = chrome.picker;
    $[15] = onClose;
    $[16] = open;
    $[17] = profileOnly;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[19] !== chrome.picker || $[20] !== profileOnly) {
    t4 = () => {
      if (profileOnly && !requested.current && !chrome.picker) {
        logger.warn("onramp.profile_entry_unavailable", {
          stage: "profile_entry"
        });
      }
    };
    t5 = [profileOnly, chrome.picker];
    $[19] = chrome.picker;
    $[20] = profileOnly;
    $[21] = t4;
    $[22] = t5;
  } else {
    t4 = $[21];
    t5 = $[22];
  }
  useEffect(t4, t5);
  const t6 = !chrome.picker && chrome.hasBack;
  let t7;
  if ($[23] !== chrome) {
    t7 = () => {
      if (chrome.hasProfile) {
        chrome.openProfile();
      } else {
        pending.current = true;
      }
    };
    $[23] = chrome;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== chrome || $[26] !== t6 || $[27] !== t7) {
    t8 = {
      chrome,
      profileReady: t6,
      openProfile: t7
    };
    $[25] = chrome;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
}